// ==============================|| OVERRIDES - PAPER ||============================== //


export default function Paper (theme) {
    return {
        MuiPaper: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.main,
                }
            }
        }
    }
}